import instance from './interceptor';

const getStoreState = () => {
  const { default: Store } = require('../Store') as { default: any };
  return Store.getState();
};

export const mutateLoginAPI = async (params: any) => {
  const { username, password } = params;
  const payload = { username, password };
  const { data } = await instance.post(`/login`, payload);
  return data;
};

export const mutateRenewTokenAPI = async () => {
  const state: any = getStoreState();
  const { data } = await instance.post(
    `/token/refresh/${state.tokenRefresh}`,
    `"${state.token}"`,
    { headers: { 'Content-Type': 'application/json' } },
  );
  return data;
};

export const mutateLogoutAPI = async (tokenRefresh: string) => {
  const { data } = await instance.post(
    `/Token/invalidate/${tokenRefresh}`,
  );
  return data;
};
